exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ba-card[data-v-be159fe8]{height:100%}.ba-card .ba-content[data-v-be159fe8]{width:100%;height:100%;display:grid;grid-template-columns:repeat(2,1fr);-ms-flex-line-pack:center;align-content:center;gap:15px}.ba-card .ba-content .ba-learn-card[data-v-be159fe8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px}.ba-card .ba-content .ba-learn-card img[data-v-be159fe8]{height:305px;border-radius:20px}.ba-card .ba-content .ba-learn-card span[data-v-be159fe8]{width:70%;color:#2a3c51}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be159fe8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/office-v6/dashboard/funnels/index.vue
// module id = 8wca
// module chunks = 0